import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

//constants
import { Constants } from '../../constants/Constants';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

@Component({
    selector: 'my-addresses-autocomplete',
    templateUrl: './AddressesAutoComplete.component.html'
})
export class AddressesAutoCompleteComponent implements OnInit {

    filteredAddresses: any[];
    selectedAddresses: string[] = [];
    addresses: ent.MyAddress[] = [];
    address: any;
    addressesModel: any;

    userInfo: ent.UserInfo;

    @Input() public placeholder: string;
    @Input() public multiple: boolean;
    @Input() public disabled: boolean;
    @Output() onSelectedAddressChanged = new EventEmitter<ent.MyAddress>();
    @Output() onFilteringAddress = new EventEmitter();
    @Output() onFilteredAddress = new EventEmitter();

    constructor(private authenticationService: serv.AuthenticationService, private addressService: serv.AddressService) {
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();

    }

    filterAddresses(event: any): void {
        var filter: filters.AddressAutoCompleteFilter = { Query: event.query };
        this.onFilteringAddress.emit();
        this.addressService.autoComplete(filter).subscribe(x => {
            this.addresses = x;
            this.filteredAddresses = []
            var id: number = 1;
            for (var address of x) {
                address.ID = id;
                this.filteredAddresses.push({ name: address.FormattedAddress, ID: id });
                id++;
            }
            this.onFilteredAddress.emit();

        });

    }


    onAddressSelected(selectedItem: any): void {
        this.selectedAddresses.push(selectedItem.FormattedAddress);
        var address = this.addresses.filter(x => x.ID == selectedItem.ID)[0];
        var filter: filters.GetAddressDetailsFilter = { Address: address };
        this.addressService.getAddressDetails(filter).subscribe(x => {
            if (x) {
                this.onSelectedAddressChanged.emit(x);
            }
        });


    }

    onAddressUnselected(selectedItem: any): void {

        _.remove(this.selectedAddresses, x => x == selectedItem.FormattedAddress);
        this.onSelectedAddressChanged.emit(new ent.MyAddress());
    }

    onClearClick(event: any) {
        this.address = new ent.MyAddress();
        this.addressesModel = this.address;
        this.selectedAddresses = [];
        this.onSelectedAddressChanged.emit(new ent.MyAddress());
    }

}